import { atwMark, type AtwMarkId } from "@/components/Brand/atwProductMarks";
import { cn } from "@/lib/utils";

type Props = {
  id: AtwMarkId;
  size?: number;
  className?: string;
  label?: boolean;
};

export function AtwProductMark({ id, size = 40, className, label = false }: Props) {
  const mark = atwMark(id);
  return (
    <img
      src={mark.src}
      width={size}
      height={size}
      alt={label ? mark.name : ""}
      aria-hidden={label ? undefined : true}
      className={cn("shrink-0", className)}
      draggable={false}
    />
  );
}
